// src/components/ServiceCard.jsx
import { Link } from "react-router-dom";

export default function ServiceCard({ title, desc, href, image, alt }) {
  const FALLBACK = "/images/placeholder.jpg";

  return (
    <Link
      to={href}
      className="group block h-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition"
    >
      {/* Big clean image */}
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-slate-100">
        <img
          src={image || FALLBACK}
          alt={alt || title}
          className="h-full w-full object-cover group-hover:scale-[1.06] transition duration-500"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = FALLBACK;
          }}
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/45 to-transparent" />
        <div className="absolute left-4 right-4 bottom-3">
          <h3 className="text-white text-base sm:text-lg font-extrabold drop-shadow">
            {title}
          </h3>
        </div>
      </div>

      <div className="p-5">
        <p className="text-sm text-slate-600 leading-relaxed">{desc}</p>
        <div className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-blue-600 group-hover:text-blue-700">
          View details <span aria-hidden>→</span>
        </div>
      </div>
    </Link>
  );
}
